import { makeCurrency } from "./currency.model";
import { makeProduct } from "./product.model";

export function makeCustomerProduct(payload) {
  return CustomerProduct.fromPayload(payload);
}

export class CustomerProduct {
  constructor() {
    this._id = null;
    this._product = null;
    this._currency = null;
    this._username = null;
    this._isActive = true;
    this._balance = null;
    this._updatedAt = null;
  }

  static fromPayload(payload) {
    let customerProduct = new CustomerProduct();

    customerProduct.id = payload.id;
    customerProduct.currency = makeCurrency(payload.currency);
    customerProduct.product = makeProduct(payload.product);
    customerProduct.username = payload.username;
    customerProduct.isActive = payload.is_active;
    customerProduct.balance = payload.balance;
    customerProduct.updatedAt = payload.updated_at;

    return customerProduct;
  }

  set id(id) {
    this._id = id;
  }

  get id() {
    return this._id;
  }

  set product(product) {
    this._product = product;
  }

  get product() {
    return this._product;
  }

  set currency(currency) {
    this._currency = currency;
  }

  get currency() {
    return this._currency;
  }

  set username(username) {
    this._username = username;
  }

  get username() {
    return this._username;
  }

  set balance(balance) {
    this._balance = balance;
  }

  get balance() {
    return this._balance;
  }

  set updatedAt(updatedAt) {
    this._updatedAt = updatedAt;
  }

  get updatedAt() {
    return this._updatedAt;
  }

  get productName() {
    return this.product.name;
  }
}



// WEBPACK FOOTER //
// ./client/app/api/models/customer-product.model.js